import { render, staticRenderFns } from "./searchControl.vue?vue&type=template&id=23a6bb53&scoped=true&"
import script from "./searchControl.vue?vue&type=script&lang=ts&"
export * from "./searchControl.vue?vue&type=script&lang=ts&"
import style0 from "./searchControl.vue?vue&type=style&index=0&id=23a6bb53&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a6bb53",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Users\\its_bas_sp_schramwy\\serviceportal\\RUB.Serviceportal\\ClientApp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('23a6bb53', component.options)
    } else {
      api.reload('23a6bb53', component.options)
    }
    module.hot.accept("./searchControl.vue?vue&type=template&id=23a6bb53&scoped=true&", function () {
      api.rerender('23a6bb53', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/molecules/searchControl.vue"
export default component.exports